/**
 * bb-nav-active.js
 * Marks the active nav item with .bb-nav-active class based on URL path matching.
 * Dawn's Liquid only sets aria-current="page" and header__active-menu-item for
 * exact URL matches. This handles all pages including blogs, collections, sub-pages.
 *
 * Design system: Active = gold (#CB9228), styled via theme-style.css Fix #7.
 */
(function () {
  'use strict';

  var currentPath = window.location.pathname.toLowerCase().replace(/\/$/, '');
  if (!currentPath) currentPath = '/';

  var navLinks = document.querySelectorAll('.header__menu-item.list-menu__item');

  navLinks.forEach(function (link) {
    var href = link.getAttribute('href');
    if (!href || href === '#') return;

    // Extract pathname from any URL format (absolute, relative, with hash)
    var linkPath;
    try {
      linkPath = new URL(href, window.location.origin).pathname.toLowerCase().replace(/\/$/, '');
    } catch (e) {
      linkPath = href.toLowerCase().replace(/\/$/, '');
    }
    if (!linkPath) return;

    // Skip home link for non-home pages to avoid false match
    if (linkPath === '' || linkPath === '/') {
      if (currentPath === '/' || currentPath === '') {
        markActive(link);
      }
      return;
    }

    // Exact match or current path starts with the nav link path
    // e.g. /blogs/whiskey-insights/some-article matches /blogs/whiskey-insights
    if (currentPath === linkPath || currentPath.indexOf(linkPath + '/') === 0) {
      markActive(link);
    }
  });

  function markActive(link) {
    link.classList.add('bb-nav-active');
    link.setAttribute('aria-current', 'page');
    var textWrapper = link.querySelector('.link_text_wrapper');
    if (textWrapper && !textWrapper.classList.contains('header__active-menu-item')) {
      textWrapper.classList.add('header__active-menu-item');
    }
  }
})();
